export const RAW_MACHINE_STAT_ENDPOINT = '/api/v1/productionline/flowStatistic/machine_stat_raw_mapped/';
export const AGGREGATED_MACHINE_STAT_ENDPOINT = '/api/v1/productionline/flowStatistic/machine_stat_aggregated/';
export const DEFAULT_LIVE_WINDOW_MINUTES = 10;
export const DEFAULT_REFRESH_INTERVAL_MS = 10_000;
export const LIVE_FLOW_STAT_SAMPLE_SECONDS = 5;

export const PRODUCTION_STOPS_ENDPOINT = '/api/v1/productionline/productionStops/';
export const PRODUCTION_STOP_REASONS_ENDPOINT = '/api/v1/productionline/productionStopReasons/';
export const PRODUCTION_STOP_LOCATIONS_ENDPOINT = '/api/v1/productionline/productionStopLocations/';
export const PRODUCTION_STOPS_REFRESH_INTERVAL_MS = 10_000;

export const EMPTY_ENTRIES = [];
